export const createArrayWithNumbers = (length: number) =>
  Array.from({ length }, (_, k) => k + 1);
